const GOOGLE_CALENDAR_URL =
  "https://calendar.google.com/calendar/render?action=TEMPLATE&text=";
const OUTLOOK_CALENDAR_URL =
  "https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent";

export const CALENDAR_URLS = {
  GOOGLE: GOOGLE_CALENDAR_URL,
  OUTLOOK: OUTLOOK_CALENDAR_URL,
};
